import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { Container as WidgetContainer } from '../../../components/Authentication/components/Container.js';
import { WidgetBody } from '../../../components/Authentication/components/WidgetBody.js';
import { resetErrors as resetApiErrors } from '../../../components/Authentication/redux/actions.js';
import { useAuthentication } from '../../../hooks/index.js';
import { DialogHead } from '../../../primitives/index.js';
import { AUTHENTICATION_QA_ID, qaId } from '../../../utils/qaId.js';
export const WidgetLayout = ({
  children,
  widget,
  ...restProps
}) => {
  const {
    toggleWidget,
    isComponentOpen
  } = useAuthentication();
  const dispatch = useDispatch();
  const handleCloseDialog = () => {
    dispatch(resetApiErrors());
    toggleWidget(widget);
  };
  return _jsxs(WidgetContainer, {
    "data-testid": qaId(AUTHENTICATION_QA_ID, `${widget}-widget`),
    open: isComponentOpen('widget', widget),
    onClose: handleCloseDialog,
    ...restProps,
    children: [_jsx(DialogHead, {
      onClose: handleCloseDialog
    }), _jsx(WidgetBody, {
      children: children
    })]
  });
};